import { ApplicationService, type ApplicationHistoryResponse } from '@acme/api';
import { createEffect, createEvent, createStore, sample } from 'effector';

export const applicationHistoryOpened = createEvent<{ id: string }>();

export const loadApplicationHistoryFx = createEffect(
  async ({ id }: { id: string }) => {
    const res = await ApplicationService.getApiV1ApplicationHistory({ id });
    if (!res.isSuccess) {
      throw new Error(
        res.errorText || 'Произошла ошибка при загрузке истории заявки'
      );
    }
    return res.data ?? [];
  }
);

export const $applicationHistory = createStore<ApplicationHistoryResponse[]>(
  []
).on(loadApplicationHistoryFx.doneData, (_, data) => data);

export const $applicationHistoryError = createStore<string | null>(null)
  .on(applicationHistoryOpened, () => null)
  .on(loadApplicationHistoryFx.failData, (_, err) =>
    err instanceof Error
      ? err.message
      : 'Произошла ошибка при загрузке истории заявки'
  );

export const $isApplicationHistoryLoading = loadApplicationHistoryFx.pending;

sample({
  clock: applicationHistoryOpened,
  filter: ({ id }) => id.trim().length > 0,
  target: loadApplicationHistoryFx,
});
